// Preview-only mirror of lud-backend/utils/menuPricing.js. The backend is
// authoritative (API responses carry `effectivePrice`); this exists so forms
// can show the result while typing. menuPricing.test.js pins it to the same
// vectors as the backend test.

export const DISCOUNT_TYPES = ["amount", "percentage"];
export const DEFAULT_PRICING_NAME = "base";

export const roundMoney = (value) => Math.round((Number(value) + Number.EPSILON) * 100) / 100;

export function calculateEffectivePrice(price, discount) {
  const base = Number(price);
  if (price === "" || price === null || price === undefined || !Number.isFinite(base)) return null;
  if (!discount) return roundMoney(base);
  const value = Number(discount.value) || 0;
  if (discount.type === "amount") return roundMoney(Math.max(base - value, 0));
  if (discount.type === "percentage") return roundMoney(Math.max(base * (1 - value / 100), 0));
  return roundMoney(base);
}

// Mirrors the backend validation so users see errors before saving.
export function pricingEntryError(entry, lang = "ar") {
  const ar = lang === "ar";
  const price = Number(entry?.price);
  if (!String(entry?.name || "").trim()) return ar ? "اسم السعر مطلوب" : "Price name is required";
  if (entry?.price === "" || entry?.price === null || !Number.isFinite(price) || price < 0) return ar ? "السعر يجب أن يكون 0 أو أكثر" : "Price must be 0 or more";
  const discount = entry?.discount;
  if (!discount) return "";
  const value = Number(discount.value);
  if (!Number.isFinite(value) || value < 0) return ar ? "قيمة الخصم غير صحيحة" : "Invalid discount value";
  if (discount.type === "amount" && value > price) return ar ? "الخصم أكبر من السعر" : "Discount exceeds the price";
  if (discount.type === "percentage" && value > 100) return ar ? "النسبة لا تتجاوز 100" : "Percentage cannot exceed 100";
  return "";
}

export function getDefaultPricing(pricing = []) {
  return pricing.find((entry) => entry?.name === DEFAULT_PRICING_NAME) || pricing[0] || null;
}

export const PRICING_NAME_LABELS = {
  ar: { base: "الأساسي", storePrice: "سعر المحل", itemPrice: "تكلفة الصنف", jahez: "جاهز", hungerstation: "هنقرستيشن", mrsool: "مرسول", keeta: "كيتا", thechefz: "ذا شفز", toyou: "تو يو", ninja: "نينجا" },
  en: { base: "Base", storePrice: "Store Price", itemPrice: "Item Cost", jahez: "Jahez", hungerstation: "HungerStation", mrsool: "Mrsool", keeta: "Keeta", thechefz: "The Chefz", toyou: "ToYou", ninja: "Ninja" },
};

export const pricingLabel = (name, lang = "ar") => PRICING_NAME_LABELS[lang]?.[name] || name;

export function formatDiscount(discount, lang = "ar") {
  if (!discount) return "";
  return discount.type === "percentage" ? `${discount.value}%` : lang === "ar" ? `${discount.value} ر` : `${discount.value} SAR`;
}
